import { render } from "./IconBack.vue?vue&type=template&id=01ee9ae1&scoped=true"
const script = {}

import "./IconBack.vue?vue&type=style&index=0&id=01ee9ae1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01ee9ae1"

export default script